if (!customElements.get('candymix-mix-cta-injector')) {
  class CandyMixMixCtaInjector extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      this.position = Number(this.dataset.position) || 6;
      this.section = this.closest('.shopify-section') || document;

      this.observer = new MutationObserver(() => {
        window.requestAnimationFrame(() => this.inject());
      });
      this.observer.observe(this.section, { childList: true, subtree: true });
      this.inject();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    inject() {
      if (!this.template) return;

      const grid = this.section.querySelector('#gf-products')
        || this.section.querySelector('#filter-results > ul.grid');

      if (!grid || grid.querySelector(':scope > .cm-mix-cta-grid-item')) return;

      const products = [...grid.children].filter((item) => item.querySelector('product-card'));
      const anchor = products[this.position - 1];
      const card = this.template.content.firstElementChild;

      if (anchor && card) anchor.after(card.cloneNode(true));
    }
  }

  customElements.define('candymix-mix-cta-injector', CandyMixMixCtaInjector);
}
